import React, { useState, useEffect } from 'react';

const LinkedInHelpPopup = ({ iconRef }) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (iconRef) {
      const rect = iconRef.getBoundingClientRect();
      const modalElement = iconRef.closest('.modal-content');

      if (!modalElement) {
        // If not in a modal, position relative to the icon itself
        setPosition({
          top: rect.top - 340, // Position above the icon
          left: rect.right + 20 // To the right of the icon with 20px gap
        });
        return;
      }

      const modalRect = modalElement.getBoundingClientRect();

      setPosition({
        top: rect.top - 340, // Position above the icon
        left: modalRect.right + 20 // To the right of the modal with 20px gap
      });
    }
  }, [iconRef]);

  return (
    <div
      className="linkedin-help-popup"
      style={{
        position: 'fixed',
        top: `${position.top}px`,
        left: `${position.left}px`,
        zIndex: 10000
      }}
    >
      <div className="help-gif-container">
        <img
          src={`${process.env.PUBLIC_URL}/copy_linkedin.gif`}
          alt="LinkedIn copy demonstration"
          className="help-gif"
        />
      </div>
      <div className="help-text">
        <strong>If you have a LinkedIn page, you can:</strong>
        <br />
        → Open your LinkedIn page
        <br />
        → <strong>Ctrl/Cmd + A</strong> to select all
        <br />
        → <strong>Ctrl/Cmd + C</strong> to copy
        <br />
        → <strong>Ctrl/Cmd + V</strong> to paste here
        <br />
        <strong>And let our AI figure out the rest!</strong>
      </div>
    </div>
  );
};

export default LinkedInHelpPopup;
